import { IWebSdkTestIssue } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';

const CSV_LIST_SEPARATOR = ', ';

export const mapWebSdkIssuesToCsvRows = (rows: IWebSdkTestIssue[]): string[][] =>
	rows.map(
		({
			id,
			detectionTime,
			crossScansId,
			firstTimeSeen,
			type,
			severity,
			wcagTags,
			summary,
			description,
			knowledgeBaseUrl,
			knowledgeBaseLinks,
			componentIds,
			component,
			selectors,
			htmlSnippets,
			url,
			pageTitle,
			note
		}) => [
			id,
			detectionTime,
			crossScansId,
			firstTimeSeen,
			type,
			severity,
			wcagTags.join(CSV_LIST_SEPARATOR),
			summary,
			description,
			knowledgeBaseUrl,
			knowledgeBaseLinks.join(CSV_LIST_SEPARATOR),
			componentIds.join(CSV_LIST_SEPARATOR),
			component,
			selectors.join(CSV_LIST_SEPARATOR),
			htmlSnippets.join(CSV_LIST_SEPARATOR),
			url,
			pageTitle,
			note
		]
	);
